import { isEmpty, isNil } from 'lodash';
import { useMemo, useState } from 'react';
import { useAppSelector } from 'src/app/hooks';
import {
  selectMap3dDataset,
  selectMap3dWorkspace,
} from 'src/map-3d/shared/map-3d-slices';
import { LayerType } from 'src/shared/api';
import {
  GenerateDTMConfirmation,
  GenerateDTMEmptyState,
  GenerateDTMForm,
  type WorkspaceLayerListObj,
} from '../..';

export const GenerateDTM: React.FC = () => {
  // useState.
  const [isGenerateDTMFormSubmitted, setIsGenerateDTMFormSubmitted] =
    useState<boolean>(false);

  // selectors.
  const { workspaceLayers } = useAppSelector(selectMap3dWorkspace);
  const { selectedTerrainIteration } = useAppSelector(selectMap3dDataset);

  // useMemos.
  const visiblePointCloudLayers: WorkspaceLayerListObj = useMemo(() => {
    return Object.fromEntries(
      Object.entries(workspaceLayers)
        .filter(
          ([, layer]) => layer.show && layer.type === LayerType.PointCloud,
        )
        .sort(
          ([, layerA], [, layerB]) =>
            (layerB.zIndex ?? 0) - (layerA.zIndex ?? 0),
        ),
    );
  }, [workspaceLayers]);

  // Variables.
  const hasValidDTMSource =
    !isEmpty(visiblePointCloudLayers) || !isNil(selectedTerrainIteration?.id);

  if (!hasValidDTMSource) {
    return (
      <div className="generate-dtm">
        <GenerateDTMEmptyState />
      </div>
    );
  }

  return (
    <div className="generate-dtm">
      {isGenerateDTMFormSubmitted ? (
        <GenerateDTMConfirmation
          setIsGenerateDTMFormSubmitted={setIsGenerateDTMFormSubmitted}
        />
      ) : (
        <GenerateDTMForm
          visiblePointCloudLayers={visiblePointCloudLayers}
          setIsGenerateDTMFormSubmitted={setIsGenerateDTMFormSubmitted}
        />
      )}
    </div>
  );
};
